<template>
  <el-upload
    action="#"
    :on-change="handleUpload"
    :http-request="limits==1?uploadAction:uploadFiles"
    :auto-upload="false"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <!-- <i slot="default" class="el-icon-plus"></i> -->
    <slot name="default"></slot>
  </el-upload>
</template>

<script>
import uploadApi from "./oss";
import dayjs from 'dayjs';
export default {
  name: "ossUploadFile",
  data() {
    return {};
  },
  props: {
    fileDir: {
      type: String,
      request: true,
    },
    limits: {
      type: Number,
      default: 0
    }
  },
  created() {},
  methods: {
    handleUpload(file, fileList) {
      if (fileList.length > 0) {
        fileList = fileList.filter((item) => item.size);
      }
      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      if (!isJPG) return this.$message.error("上传图片只能是 JPEG/PNG 格式!");
      if(this.limits==1){
        this.uploadAction(file.raw, this.fileDir);
      }else{
        this.uploadFiles(fileList, this.fileDir);
      }
    },
    /**
     * @description: 多张上传
     * @param {*} files
     * @param {*} fileDir
     * @return {*}
     */    
    async uploadFiles(files, fileDir) {
      let urls = await uploadApi.uploadFiles(files, fileDir);
      this.$emit("upload", urls);
    },
    /**
     * @description: 单张上传
     * @param {*} files
     * @param {*} fileDir
     * @return {*}
     */
    async uploadAction(files, fileDir) {
      let randomNum = ('00000' + Math.floor(Math.random() * 99999)).slice(-5)
      let suffix = files.type.split('/')[1]?files.type.split('/')[1]:'jpg'
      let fileName = dayjs(new Date()).format('YYYYMMDDHHmmss')+'_'+randomNum+'.'+ suffix
      let urls = await uploadApi.uploadAction({file:files, fileDir, fileName});
      this.$emit("upload", `${uploadApi.baseUrl}${urls.name}`);
    },
  },
};
</script>

<style scoped lang="scss"></style>
